import { render, staticRenderFns } from "./ColorBanner.vue?vue&type=template&id=13d8e1e8&scoped=true"
import script from "./ColorBanner.vue?vue&type=script&lang=js"
export * from "./ColorBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8e1e8",
  null
  
)

export default component.exports